import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { SettingsActions } from '../../../redux/Settings';

const Styled = styled.button`
  width: 380px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  border: 0px solid #302220;
  border-radius: 4px;
  background-color: rgba(27, 0, 0, 0);
  color: #d2c8ae;
  padding: 0em;
  min-height: 14px;
  margin-bottom: 0.4em;
  font-size: 18px;
`;

const Rule = ({ rule, canRoll }) => {
  const dispatch = useDispatch();
  const text = () => {
    return (
      <div>
        {canRoll ? <span>@ </span> : ''}
        <span>{rule.ruleString}</span>
      </div>
    );
  };
  return (
    <Styled
      title={rule.description}
      disabled={!canRoll}
      onClick={() => dispatch(SettingsActions.rollRule(rule))}
    >
      {text()}
    </Styled>
  );
};

Rule.propTypes = {
  rule: PropTypes.objectOf(PropTypes.string),
  canRoll: PropTypes.bool,
};

export default Rule;
